import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';

export default function MarkDiscount({
    item = {},
    priceMax,
    priceMin,
    TextA = {},
    locale,
}: {
    item: any;
    priceMax: number;
    priceMin: number;
    TextA: any;
    locale: string;
}) {
    const discountLabelType = item.discountLabelType;
    if (priceMax === priceMin && discountLabelType !== 'discountLabelFixed') {
        return null;
    }
    let textA1 = '';
    const isUseOffText = discountLabelType === 'discountLabelPercentage'; // 折扣百分比
    const countRetentionMethod = item.countRetentionMethod;
    if (discountLabelType === 'discountLabelFixed') {
        //固定文案
        textA1 = item.discountLabelFixedText;
    } else if (discountLabelType === 'discountLabelPercentage' && priceMin && priceMax) {
        // 折扣百分比
        let currentScale = 100 - (priceMin * 100) / priceMax;

        if (countRetentionMethod === 'rounding') {
            // 四舍五入
            currentScale = Math.round(currentScale);
        } else if (countRetentionMethod === 'onlyInt') {
            //去掉小数取整
            currentScale = parseInt(`${currentScale}`);
        }
        textA1 = `${currentScale}%`;
    } else if (discountLabelType === 'discountLabelNumber' && priceMin && priceMax) {
        let currentNum = priceMax - priceMin;
        if (countRetentionMethod === 'rounding') {
            // 四舍五入
            currentNum = Math.round(currentNum);
        } else if (countRetentionMethod === 'onlyInt') {
            //去掉小数取整
            currentNum = parseInt(`${currentNum}`);
        }
        textA1 = `${FormatMoneyLocal(currentNum, locale)}`;
    }
    if (!textA1) {
        return null;
    }
    return (
        <div className="member-product-scene-item-corner-mark-discount">
            {['fr', 'de'].includes(locale) ? (
                <>
                    {isUseOffText && <span className="member-product-scene-item-corner-mark-discount-text2">&nbsp;{TextA.OFF}</span>}
                    <span className="member-product-scene-item-corner-mark-discount-text1">{textA1}</span>
                </>
            ) : (
                <>
                    <span className="member-product-scene-item-corner-mark-discount-text1">{textA1}</span>
                    {isUseOffText && <span className="member-product-scene-item-corner-mark-discount-text2">&nbsp;{TextA.OFF}</span>}
                </>
            )}
        </div>
    );
}
